// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4830":"649f2d03","5115":"79a70c36","5596":"79a70c36","6475":"fa307a89","7706":"8a0cf7be"}[chunkId] + ".chunk.css";
};